<div class="d-flex align-items-center justify-content-center p-4 text-18">
  Loading Packages
  <span class="text-loader" role="status"></span>
</div>
